export default {
  strict: true,
  namespaced: true,
  state: {
    paymentSummaryForm: false
  },
  mutations: {
    setRerenderData (state, data) {
      for (let field in data) {
        state[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/rerender.js